@use '@scss' as *;

@layer module {
.pro-card {
            display: flex;
            flex-direction: column;
    }

.pro-card__title-row {
            position: relative;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
    }

.pro-card__body-row {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            flex: 1;
    }

.pro-card__donut {
            flex-shrink: 0;
    }

.pro-card__legend {
            flex: 1;
            min-width: 0;
            display: flex;
            flex-direction: column;
    }

.pro-card__legend-item {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            min-width: 0;
    }

.pro-card__legend-label {
            display: inline-flex;
            align-items: center;
            flex: 1 1 auto;
            min-width: 0;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
    }

.pro-card__legend-dot {
            flex-shrink: 0;
    }

.pro-card__section-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
    }

.pro-card__empty {
            text-align: center;
    }

.pro-card__content {
            flex: 1;
            display: flex;
            flex-direction: column;
            overflow: hidden;
            min-height: 0;
    }

.pro-card__footer {
            text-align: center;
    }

.pro-card__footer-link {
            border: none;
            cursor: pointer;
            display: inline-flex;
            align-items: center;
            transition: color 0.15s;
    }

.pro-card__skeleton-row {
            display: flex;
            align-items: center;
            flex: 1;
    }

.pro-card__skeleton-circle {
            flex-shrink: 0;
    }

.pro-card__skeleton-lines {
            flex: 1;
            display: flex;
            flex-direction: column;
    }
} // layer module










@layer app {
.pro-card {
            border-radius: $size-18;
            padding: $size-18 $size-20;
    }

.pro-card--brand,
.pro-card--action {
            border-radius: $size-20;
            padding: $size-22 $size-24;
    }

.pro-card__title-row {
            margin-bottom: $size-8;
    }

.pro-card__title {
            margin: 0;
    }

.pro-card__subtitle {
            margin: 2px 0 0;
    }

.pro-card__body-row {
            gap: $size-24;
            margin-top: $size-10;
    }

.pro-card__donut {
            width: $size-128;
            height: $size-128;
    }

.pro-card__legend {
            gap: $size-12;
    }

.pro-card__legend-item {
            gap: $size-10;
    }

.pro-card__legend-dot {
            width: $size-10;
            height: $size-10;
            border-radius: $size-3;
            margin-right: $size-10;
    }

.pro-card__section-header {
            margin-bottom: $size-20;
            height: $size-20;
    }

.pro-card__section-title {
            margin: 0;
    }

.pro-card__empty {
            margin: $size-16 0;
    }

.pro-card__footer {
            margin-top: $size-20;
            padding-top: $size-16;
    }

.pro-card__footer-link {
            padding: 0;
            gap: $size-4;
    }

.pro-card__skeleton-row {
            gap: $size-16;
    }

.pro-card__skeleton-circle {
            width: $size-128;
            height: $size-128;
            border-radius: 50%;
    }

.pro-card__skeleton-lines {
            gap: $size-8;
    }

.pro-card__skeleton-line {
            height: $size-10;
            border-radius: $size-4;
            width: 100%;
    }

      @media (max-width: 480px) {
                .pro-card__donut {
                        width: $size-96;
                        height: $size-96;
                    }
          }

.pro-card__footer-link {
            background: none;
    }

.pro-card {
            border: 1px solid var(--dash-border);
            background: var(--dash-bg-card);
            color: var(--text-primary);
    }

.pro-card--brand {
            border-color: transparent;
            background: var(--color-brand);
            color: var(--color-on-brand);
    }

.pro-card--action {
            border-color: transparent;
            background: var(--color-action);
            color: var(--color-on-action);
    }

.pro-card__footer {
            border-top: 1px solid var(--dash-border-soft);
    }

.pro-card__skeleton-circle {
            background: var(--dash-border-soft);
    }

.pro-card__title {
            font-size: var(--font-size-base);
            font-weight: 500;
            color: var(--text-primary);
    }

.pro-card__subtitle {
            font-size: var(--font-size-sm);
            font-weight: 400;
            color: var(--text-secondary);
    }

.pro-card__legend-item {
            font-size: var(--font-size-base);
            color: var(--text-primary);
    }

.pro-card__legend-code {
            margin-left: $size-4;
            color: var(--text-secondary);
            font-size: var(--font-size-sm);
    }

.pro-card__legend-pct {
            font-weight: 600;
    }

.pro-card__section-title {
            font-size: var(--font-size-base);
            font-weight: 600;
            color: var(--dash-text-primary);
    }

.pro-card__empty {
            color: var(--dash-text-faint);
            font-size: var(--font-size-base);
    }

.pro-card__footer-link {
            font-size: var(--font-size-sm);
            font-weight: 600;
            color: var(--dash-text-muted);
    }

.pro-card__footer-link:hover {
            color: var(--dash-accent);
    }
} // layer app










@layer context {
.pro-card:global(.balance-chart-card) {
            min-height: $size-340;
            overflow: hidden;
    }

.pro-card:global(.kpi-card) {
            gap: $size-6;
            min-width: 0;
            padding: $size-16 $size-18;
    }

.pro-card:global(.kpi-card--skeleton) {
            gap: $size-10;
    }

.pro-card:global(.filter-bar) {
            gap: $size-10;
            padding: $size-14 $size-20;
    }

.pro-card:global(.section-card) {
            gap: $size-16;
            padding: $size-20 $size-22;
    }

.pro-card:global(.support-shell-list),
.pro-card:global(.support-shell-conversation) {
            min-width: 0;
            padding: 0;
            overflow: hidden;
    }

.pro-card:global(.support-shell-list) {
            max-height: 100%;
    }

.pro-card:global(.settings-danger-card) {
            border-color: var(--color-error-tint);
    }

.pro-card:global(.side-panel) {
            padding: 0;
            overflow: hidden;
    }

.pro-card:global(.account-list) {
            min-height: $size-360;
            padding: 0;
            overflow: hidden;
    }

.pro-card:global(.account-workspace) {
            gap: $size-22;
            padding: $size-20;
    }

.pro-card--brand:global(.account-hero) {
            gap: $size-22;
            overflow: hidden;
            border-radius: $size-16;
            padding: $size-24 $size-26;
    }

.pro-card--brand:global(.staff-account-card) {
            gap: $size-8;
            border-radius: $size-18;
            padding: $size-16 $size-18;
    }

.pro-card__footer-link:global(.account-transactions-footer) {
            display: flex;
            justify-content: center;
            width: 100%;
            padding: $size-14 $size-20;
            text-decoration: none;
    }

.pro-card:global(.refer-and-earn-commission-card),
.pro-card:global(.refer-and-earn-payout-card),
.pro-card:global(.refer-and-earn-volume-card) {
            min-width: 0;
    }

.pro-card:global(.refer-and-earn-hero) {
            position: relative;
            flex-direction: row;
            overflow: hidden;
            padding: $size-26 $size-24;
    }

:global(.enterprise-dashboard__side) :global(.donut-card) .pro-card__empty {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0;
    }

      @media (min-width: 1281px) {
                :global(.enterprise-dashboard__side) .pro-card {
                        min-height: $size-190;
                    }
          }

      @media (min-width: 1100px) and (max-height: 949px) {
                .pro-card:global(.balance-chart-card) {
                        min-height: 0;
                    }
          }

      @media (min-width: 900px) and (max-height: 949px) {
                .pro-card:global(.spending-tracker) {
                        padding: $size-16 $size-24;
                    }
          }

      @media (max-width: 960px) {
                .pro-card:global(.account-list) {
                        min-height: 0;
                        max-height: $size-360;
                    }
          }

      @media (max-width: 768px) {
                .pro-card:global(.refer-and-earn-hero) {
                        flex-direction: column;
                    }
          }
} // layer context
